import { render } from "./SearchContainer.vue?vue&type=template&id=2beb50b6&ts=true"
import script from "./SearchContainer.vue?vue&type=script&lang=ts"
export * from "./SearchContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/MS/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__